export enum ENVIRONMENT {
  RELEASE = "release",
  STAGING = "staging",
  UAT = "uat",
  PRODUCTION = "production",
}
